
import { CustomButton } from '../../../components/customButton/CustomButton';
import { Grid } from '@mui/material';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';

export const ControlVisitaFilters = ({
    delegaciones,
    estadosOptions,
    tipoProfesionalesOptions,
    aniosOptions,
    mesesEnum,
    filters,
    handleSearch,
    handleChangeFilters
}) => {

    const handleTextClean = () => {
        handleChangeFilters('txtFiltro', '');
    };

    return (
        <Grid
            container
            spacing={2}
            sx={{ marginBottom: '25px' }}
        >
            <Grid size={{ xs: 6, sm: 6, md: 4, lg: 2, xl: 2 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'search',
                        displayName: 'Buscador',
                        name: 'txtFiltro',
                        key: `${filters?.txtFiltro}-buscador`,
                        onClearButtonClick: handleTextClean
                    }}
                    value={filters.txtFiltro}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 4, lg: 2, xl: 2 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'select',
                        displayName: 'Delegacion',
                        name: 'idDelegacion',
                        options: delegaciones,
                        key: `${filters?.idDelegacion}-delegacion`
                    }}
                    value={filters.idDelegacion}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 4, lg: 2, xl: 2 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'select',
                        displayName: 'Tipo Profesional',
                        name: 'idTipoProfesional',
                        options: tipoProfesionalesOptions,
                        key: `${filters?.idTipoProfesional}-tipoProfesional`
                    }}
                    value={filters?.idTipoProfesional}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 4, lg: 2, xl: 2 }}>
                <RenderInputByTypeMobile
                    input={{
                        displayName: 'Estado',
                        type: 'select',
                        name: 'estado',
                        options: estadosOptions
                    }}
                    value={filters.estado}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 3, lg: 2, xl: 2 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'select',
                        displayName: 'Mes',
                        name: 'mes',
                        options: mesesEnum.map(x => ({ id: x.code, displayName: x.name }))
                    }}
                    value={filters.mes}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 3, lg: 1, xl: 1 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'select',
                        displayName: 'Año',
                        name: 'anio',
                        options: aniosOptions
                    }}
                    value={filters.anio}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid sx={{ textAlign: 'right' }} size={{ xs: 6, sm: 6, md: 2, lg: 1, xl: 1 }}>
                <CustomButton
                    variant='contained'
                    onClick={() => handleSearch()}
                    size='small'
                >
                    Buscar
                </CustomButton>
            </Grid>
        </Grid >
    )
}
